import { merge } from 'lodash-es';
import { ofType } from 'redux-observable';
import { EMPTY } from 'rxjs';
import { catchError, map, switchMap, take, withLatestFrom } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';
import type { WorkspaceType } from 'state/workspaces/model';
import { workspaceLoadFromLocalStorage } from 'state/workspaces/workspaces/workspace.actions';
import type { WorkspacesStateMap } from 'state/workspaces/workspaces/workspaces.model';
import { getSnapshotFromLocalStorage } from 'state/workspaces/workspaces/workspaces.selector';

export interface ProductSelectorLocalStoragePayload {
  seenDisclaimer: WorkspaceType[];
}

export function saveToLocalStorageEpic(): EpicWithThunk {
  return (action$, state$, { localStorageApiConnector, frontLogger }) =>
    action$.pipe(
      ofType('WORKSPACE_SAVE_TO_LOCAL_STORAGE'),
      withLatestFrom(state$),
      switchMap(([action, state]) => {
        const snapshot = getSnapshotFromLocalStorage(state);
        const toBeSaved = merge({}, snapshot, { [action.workspace]: action.keyValuePair });

        return localStorageApiConnector('workspaces', {})
          .save(toBeSaved)
          .pipe(
            // ignoreElements(),
            map(() => workspaceLoadFromLocalStorage(toBeSaved)),
            catchError((error: Error) => {
              frontLogger.error('An error occurred inside saveSeenDisclaimer {@FrontError}', error);
              return EMPTY;
            }),
          );
      }),
    );
}

export function loadFromLocalStorageEpic(): EpicWithThunk {
  return (actions$, _state$, { localStorageApiConnector, frontLogger }) =>
    actions$.pipe(ofType('USER_CURRENT_RECEIVED'), take(1)).pipe(
      switchMap(_ => {
        return localStorageApiConnector('workspaces', [])
          .load<DeepPartial<WorkspacesStateMap>>()
          .pipe(
            map(payload => workspaceLoadFromLocalStorage(payload)),
            catchError((error: Error) => {
              frontLogger.error('An error occurred inside loadSeenDisclaimers {@FrontError}', error);
              return EMPTY;
            }),
          );
      }),
    );
}
